import { CommonModule, DatePipe, NgIf, NgStyle } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { GeneralDialogOkComponent } from 'src/app/core/dialog/general-dialog-ok/general-dialog-ok.component';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import {
  IApnSpaceEmailLink,
  ILotList,
  INonActiveAccountResendRequest,
  IParkerActivationReturnData,
  IParkersNonActiveSpaceAccounts,
  IParkersReadyForactivation,
} from 'src/app/shared/interfaces';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-parker-v2-non-active-space-accounts',
  templateUrl: './parker-v2-non-active-space-accounts.component.html',
  styleUrl: './parker-v2-non-active-space-accounts.component.scss',
  standalone: true,
  imports: [MatProgressSpinnerModule, NgStyle, DatePipe, NgIf, CommonModule],
})
export class ParkerV2NonActiveSpaceAccountsComponent implements OnInit {
  isUserAdmin: boolean = false;
  userName: string = '';
  LotListByUserName: ILotList[] = [];
  lotNumber: string = '';
  nonActiveAccounts: IParkersNonActiveSpaceAccounts[] = [];
  selectedLot: string = '';
  gridFontSize: number = 12;
  numberOfParkersSelected: number = 0;
  allParkersChecked: boolean = false;
  spaceNonActiveAccounts: INonActiveAccountResendRequest[] = [];
  parkerActivationReturnData: IParkerActivationReturnData[] = [];
  isProcessingNewUsers: boolean = false;
  lotDisplayName: string = '';
  urlDomain: string = '';
  queryPerformed: boolean = false;

  //Services
  _appGeneralState = inject(AppGeneralStateService);

  constructor(
    private authService: AuthService,
    private dataService: DataService,
    private _parkerState: ParkerStateService,
    private routerService: Router,
    private _matDialog: MatDialog,
  ) {
    this.userName = this._appGeneralState.userName;
    this.urlDomain = environment.UrlDomain;
    if (this.userName == '') {
      this.routerService.navigate([`/badroute`]);
    }

    this.lotNumber = this._appGeneralState.currentLotNumber;
    this.lotDisplayName = this._appGeneralState.currentLotNumber + ' - ' + this._appGeneralState.currentLotName;
  }

  ngOnInit(): void {
    //  this.getSpaceIdByEmailAddress(this.userName);
  }

  onNavToParkersHome(): void {
    this.routerService.navigate([`/parkerlist`]);
  }

  isParkerFlaggedForActivation(rowIndex: number): boolean {
    return this.nonActiveAccounts[rowIndex].activateFlag === true;
  }

  onCheckParker(parkerId: string): void {
    let ii: number;
    let isFlagged: boolean = false;

    for (ii = 0; ii < this.nonActiveAccounts.length; ii++) {
      if (this.nonActiveAccounts[ii].parkerId === parkerId) {
        this.nonActiveAccounts[ii].activateFlag = !this.nonActiveAccounts[ii].activateFlag;
      }
    }

    this.setNumberOfParkersSelected();
  }

  onResendSpaceNonActiveAccounts(): void {
    let ii: number = 0;

    for (ii = 0; ii < this.nonActiveAccounts.length; ii++) {
      let aNonActiveAccount: INonActiveAccountResendRequest = {} as INonActiveAccountResendRequest;
      if (this.nonActiveAccounts[ii].activateFlag) {
        aNonActiveAccount.emailAddress = this.nonActiveAccounts[ii].emailAddress;
        aNonActiveAccount.parkerId = this.nonActiveAccounts[ii].parkerId;
        aNonActiveAccount.lotNumber = this.nonActiveAccounts[ii].lotNumber;
        aNonActiveAccount.spaceUserId = 0;
        aNonActiveAccount.lastModifiedByUserId = this._appGeneralState.userName;
        aNonActiveAccount.lastDateEmailResend = new Date();

        this.spaceNonActiveAccounts.push(aNonActiveAccount);
      }
    }

    this.postNewSpaceEmail(this.spaceNonActiveAccounts);
  }

  postNewSpaceEmail(nonActiveSpaceAccounts: INonActiveAccountResendRequest[]) {
    let newSpaceEmailId: number;
    this.isProcessingNewUsers = true;
    this.dataService.postParkerResendSpaceNonActiveAccounts(nonActiveSpaceAccounts).subscribe(
      (res) => {
        this.parkerActivationReturnData = res;
        this.isProcessingNewUsers = false;
      },
      (err: any) => {
        this.isProcessingNewUsers = false;
        this.spaceNonActiveAccounts = [];
      },
      () => {
        let ii: number;
        this.spaceNonActiveAccounts = [];
        this.processNewUsersAfterAdding();
      },
    );
  }

  onToggleCheckAll(): void {
    this.allParkersChecked = !this.allParkersChecked;
    let ii: number;

    for (ii = 0; ii < this.nonActiveAccounts.length; ii++) {
      this.nonActiveAccounts[ii].activateFlag = this.allParkersChecked;
    }

    if (this.allParkersChecked) {
      this.numberOfParkersSelected = this.nonActiveAccounts.length;
    } else this.numberOfParkersSelected = 0;
  }

  setNumberOfParkersSelected(): void {
    let ii: number = 0;

    this.numberOfParkersSelected = 0;

    for (ii = 0; ii < this.nonActiveAccounts.length; ii++) {
      if (this.nonActiveAccounts[ii].activateFlag === true) this.numberOfParkersSelected++;
    }
  }

  onSubmitFindParkersSpaceNonActiveAccounts(): void {
    this.queryPerformed = true;
    this.allParkersChecked = false;
    this.getParkersNonActiveAccountList(this.lotNumber);
  }

  processNewUsersAfterAdding(): void {
    let ii: number;
    let jj;
    this.numberOfParkersSelected;

    for (ii = 0; ii < this.parkerActivationReturnData.length; ii++) {
      for (jj = 0; jj < this.nonActiveAccounts.length; jj++) {
        if (this.parkerActivationReturnData[ii].parkerId === this.nonActiveAccounts[jj].parkerId) {
          if (this.parkerActivationReturnData[ii].status === true) this.nonActiveAccounts[jj].result = 1;
          else this.nonActiveAccounts[jj].result = 2;
        }
      }
    }
  }

  DisplayNoParkersFounddDialog(): void {
    const dlgTitle: string = 'No Parkers Found.';
    const dlgLine1: string = 'Lot ' + this.lotDisplayName;
    const dlgLine2: string = '';
    let enterAnimationDuration: string = '0ms';
    let exitAnimationDuration: string = '0ms';

    const dialogRef = this._matDialog.open(GeneralDialogOkComponent, {
      data: { dlgTitle: dlgTitle, dlgLine1: dlgLine1, dlgLine2: dlgLine2 },
      width: '450px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

  getParkersNonActiveAccountList(lotNumber: string) {
    this.dataService.getParkersNonActiveSpaceAccountsByLotNumber(lotNumber).subscribe(
      (parkerList) => {
        this.nonActiveAccounts = parkerList;
      },
      (err: any) => {},
      () => {
        let ii: number = 0;
        for (ii = 0; ii < this.nonActiveAccounts.length; ii++) {
          this.nonActiveAccounts[ii].result = 0; //0 = not submitted;
        }

        if (this.nonActiveAccounts.length == 0) this.DisplayNoParkersFounddDialog();
      },
    );
  }

  getLotListsNotRestrictedForSpaceActivation() {
    this.dataService.GetAdminMassActivationLotList().subscribe(
      (LotListByUserName) => {
        this.LotListByUserName = LotListByUserName;
      },
      (err: any) => {},
      () => {},
    );
  }

  getSpaceIdByEmailAddress(userName: string): void {
    let spaceUserid: number;

    this.dataService.getIsUserAdmin(userName).subscribe(
      (res) => {
        this.isUserAdmin = res;
      },
      (err: any) => {},
      () => {
        if (!this.isUserAdmin) {
          this.routerService.navigate([`/badroute`]);
        }

        let userName: string = this._appGeneralState.userName;
        if (userName === 'kmoss' || userName === 'lgonzalez' || userName === 'jizigzon') {
        } else this.routerService.navigate([`/badroute`]);
      },
    );
  }
}
